import { SerializableObject } from "./serializable-object";

export enum BrandEmailIntegrationType {
  GMAIL = "GMAIL",
  OUTLOOK = "OUTLOOK",
  IMAP = "IMAP",
}

export class BrandEmailIntegration extends SerializableObject {
  isConnected!: boolean;
  integrationDetail!: BrandEmailIntegrationDetail;
  inviteEmailTemplate!: string;

  protected coercePropertyType(propertyName: string, propertyValue: any) {
    switch (propertyName) {
      case "integrationDetail":
        return new BrandEmailIntegrationDetail(propertyValue);
      default:
        return propertyValue;
    }
  }
}

export class BrandEmailIntegrationDetail extends SerializableObject {
  type!: BrandEmailIntegrationType;
  email!: string;
  password!: string;
  host!: string;
  port!: number;
  accessTokenExpired!: boolean;
}

export class BrandEmailIntegrationImap {
  constructor(
    public readonly email: string,
    public readonly password: string,
    public readonly host: string,
    public readonly port: number,
  ) {}
}

export class BrandInvitePartnerEmail {
  toEmails!: string[];
  emailSubject!: string;
  emailContent!: string;
  partnerImportId!: number;
  attachmentAssetIds!: number[];
}
